module.exports = __webpack_public_path__ + "static/media/PoiretOne-Regular.c57e537a.ttf";